module.exports = {
	pt_BR: {
		botao: {
			salvar: 'Salvar',
			fechar: 'Fechar',
			novo: 'Novo',
			voltar: 'Voltar',
			excluir: 'Excluir',
		},

		erro: {
			titulo: {
				http: 'Alerta de Conexão HTTP'
			},
			erro: 'Erro',
			token_invalido: 'Token Inválido ou expirado.',
			acesso_nao_autorizado: 'Acesso não autorizado.',
			error_api_novo_pedido: 'Error na API de criação de pedidos, tente novamente mais tarde.',
			error_api_consulta_pedido_503: 'Serviço não está disponível no momento. Serviço solicitado pode estar em manutenção ou fora da janela de funcionamento.',
			error_api_consulta_pedido: 'Não foi possível criar cobrança. Entre em contato com o suporte.',
			
			error_api_consulta_qrcode_pedido_503: 'Serviço não está disponível no momento. Serviço solicitado pode estar em manutenção ou fora da janela de funcionamento.',
			error_api_consulta_qrcode_pedido: 'Serviço não está disponível no momento. Serviço solicitado pode estar em manutenção ou fora da janela de funcionamento.',
			
			error_api_consulta_qrcode_pedido_204: 'Solicitação processada com sucesso, mas não está retornando nenhum conteúdo.',
			error_api_consulta_pedido_204: 'Solicitação processada com sucesso, mas não está retornando nenhum conteúdo.',
			error_api_consulta_qrcode_pedido_404: 'QRCode não encontrado.',

			error_api_registrar_txid: 'Error na API de que registra o TxId, tente novamente mais tarde.',
			error_api_criar_cobranca_pix: 'Error na API ao criar cobranca PIX, tente novamente mais tarde.',
		},
		the: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},
        tag: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},
        ali: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},
        ctd: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},
        lza: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},
		fln: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},
        fle: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},
        sca: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},
		gvb: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador ou número do chip e seu CPF.',
		},
		mba: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},
        pnv: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},
        utb: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},          
        mmc: {
			informar_cartao_cpf: 'Informe o número de seu cartão + dígito verificador e seu CPF.',
		},


		label: {
            estou_cinte: 'Estou ciente',
            processando: 'Processando...',
			dados_invalidos: 'Dados inválidos',
			preencha_dados: 'Preencha os dados corretamente',
            preencha_dados_para_emitir_boletos: 'Preencha corretamente o seu cadastro, clique no botão "Dados cadastrais',
			preencha_email: 'Preencha o email corretamente',
            acesso_negado_0360: 'Acesso não permitido, vá ao posto-sede do SETUT e faça a revalidação do chip do seu cartão',
			preencha_logradouro: 'Preencha o logradouro corretamente',
            preencha_tipo_logradouro: 'Preencha o tipo de logradouro',
			preencha_complemento: 'Preencha o complemento corretamente',
			preencha_numero: 'Preencha o número corretamente',
			preencha_bairro: 'Preencha o bairro corretamente',
			preencha_cep: 'Preencha o CEP corretamente',
			dados_salvo: 'Dados salvos com sucesso!',
            limite_de_compra: 'Limite de compra',
			servico_indisponivel: 'Serviço indisponível no momento!',
			pedido_criado: 'Pedido criado com sucesso!',
			descricao_modal_inicial: 'As cargas solicitadas neste site são realizadas por meio de geração de boleto. Modalidade esta que exige compensação bancária. Dessa forma, os créditos estarão disponíveis para recebimento nos validadores dos ônibus em até 3 dias úteis após a confirmação do pagamento.',				
			aviso: 		'Aviso',
			acessar: 'Acessar',
            ou: 'ou',
            login: 'Login',
            situacao: 'Situação',
            painel_adm: 'Painel ADM',
            preencha_login: 'Preencha campo login',
            preencha_senha: 'Preencha campo senha',
			complemento: 'Complemento',
			cep: 'CEP',
			bairro: 'Bairro',
			no: 'No.',
			bem_vindo: 	'Bem Vindos',
			novo_pedido: 'Novo pedido',
			acesso_portal_de_compras: 'Acesso ao portal de compra de créditos',
            acesso_painel_adm: 'Acesso ao painel de ADM',
			boleto: 'Boleto',
			pix: 'Pix',
			pago: 'Pago',
			como_localizar_cod: 'Como localizar o número do seu cartão ou chip?',
			cod: 'Cod',
			cpf: 'CPF',
			codigo:	'Código',
			codigo_cartao: 'Código do cartão',
			dashboard: 'Dashboard',
			dados: 'Dados do Cartão',
			digito: 'Dígito',
			tipo_do_logradouro: 'Tipo do logradouro',
			tipo_de_logradouro: 'Tipo de logradouro',
			logradouro: 'Logradouro',
			data_referencia_saldo: 'Data de referência do saldo',
			dados_tipo_ocorrencia: 'Dados do tipo de Ocorrência',
			dados_grupo_tipo_ocorrencia: 'Dados do Grupo de Tipo de Ocorrência',
			dados_grupo_usuarios: 'Dados do Grupo de Usuários',
			informacao_recarga: 'Informação para recarga',
            status_documento: 'Status do documento: ',
			descricao: 	'Descrição',
			gerar: 	'Gerar',
			gerar_pdf: 'Gerar PDF',
			gerar_xlsx: 'Gerar XLSX',
			gerar_csv: 'Gerar CSV',
			dados_cadastrais: 'Dados cadastrais',
			apos_pagamento_pix: 'Após o pagamento do pix, consultar o status na tela de pedidos! Os créditos estarão disponíveis em até 48 horas.',
			infracao: 	'Infração',
			inicio:		'Início',
			nao: 'Não',			
			numero: 'Numero',	
			numero_chip: 'Número do Chip',
			observacao: 'Observação',
			pontuacao: 'Pontuação',
			pesquisar: 'Pesquisar',
			relatorio1: 'Relatorio 1',
			sobre: 'Sobre',
			sim: 'Sim',
			ou: 'OU',
			ok: 'OK',
			mais: '+',
			menos: '-',
			valor_recarga: 'Valor recarga',
			tarifa: 'Tarifa',
            cartao_nao_habilitado_para_carga: 'Cartão não habilitado para carga neste canal',
			selecionar_uma_tarifa_por_favor: 'Selecionar uma tarifa, por favor.',
			quantidade:'Quantidade',
			interrogacao: '?',
			tem_certeza_que_deseja_recarregar: 'Tem certeza que deseja recarregar ',
			no_cartao_com_codigo: ' no cartão com código ',
			tipos_de_ocorrencias: 'Tipos de Ocorrências',
			grupo_tipo_ocorrencia: 'Grupos de Tipo Ocorrência',
			usuario: 'Usuários',
			grupo_usuario: 'Grupos de Usuários',
			perfis_usuarios: 'Perfis de Usuários',
			grupo_usuario_associacao: 'Escolha o(s) grupo(s) que deseja adicionar o usuário',
			grupo_usuario_escolha: 'Escolha o(s) grupo(s)',
			seleciona_enter: 'Pressione enter para selecionar',
			selecionado: 'Selecionado',
			municipio: 'Município',
			forma_de_pagamento: 'Forma de pagamento',
            metodo_pagamento: 'Método de pagamento',
			remove_enter: 'Pressione enter para remover',
			buscar_grupo: 'Buscar Grupo',
			nao_ha_grupos: 'Não existe(m) grupo(s) cadastrados.',
			usuarios: 'Usuários',
			cadastrar_usuarios: 'Cadastrar Usuários',
			nome: 'Nome',
			titular: 'Titular',
			email: 'E-Mail',
			dashboard1: 'Dashboard 1',
			dashboard2: 'Dashboard 2',
			senha: 'Senha',
			recibo: 'Recibo',
			saldo_no_cartao: 'Saldo cartão',
			nome_usuario: 'Nome Usuário',
			modulo_xpto: 'Módulo XPT',
			modulo_abc: 'Módulo ABC',
			modulo_relatorios: 'Módulo Relatórios',
			acoes: 'Ações',
            cadastro_estudantil: 'Cadastro Estudantil',
            selecione_um_tipo_de_documento: 'Selecione o tipo de documento',
			excluir: 'Excluir',
            arquivo: 'Arquivo',
            preencha_foto3x4: 'Faça upload da imagem da foto 3x4.',
            preencha_comprovante_matricula: 'Faça upload da imagem do comprovante de matricula.',
            preencha_comprovante_cadastro: 'Faça upload da imagem do comprovante de cadastro.',
            preencha_cpf: 'Faça upload da imagem do CPF.',
            preencha_rg: 'Faça upload da imagem do RG.',
            preencha_carteira_estudante_frente: 'Faça upload da imagem da frente da identidade.',
            preencha_carteira_estudante_verso: 'Faça upload da imagem do verso da identidade.',
            salvando:"Salvando... (Por favor, permaneça nesta tela)",
            dimensao_maxima: 'Dimensão inválida, selecione uma imagem 159x129.',
            selecione_arquivo: 'Selecione o arquivo',
			estudante_do_curso: 'Estudante do curso ',
			do_ano_letivo: ', do ano letivo ',
            documentos_enviados: 'Documentos enviados. Prazo para análise dos documentos é de 7 dias.',
			com_inicio_em: ' com início em ',
			ate: ', até ',
			local_recarga_informativo_um: 'Veja outras formas de recarregar seu CartãoGV:',
			local_recarga_informativo_dois: '● Aplicativos disponíveis no app ÔnibusGV ( Banestes, Kim Recarga, Recarga Pay e PicPay)',
			link_como_chegar_ao_destino: 'https://www.cartaogv.com.br/como-chegar-ao-destino/',			
			local_recarga_informativo_tres: '● Mais de 130 pontos de vendas do CartãoGV e de recarga espalhados pela Grande Vitória, que vão desde farmácias a outros estabelecimentos;',			
			local_recarga_informativo_quatro: '● Máquinas de autoatendimento em todos os shoppings, na Rodoviária de Vitória e no Masterplace Mall.',			
			local_recarga_informativo_cinco: '● Máquinas de autoatendimento em todos os terminais do Sistema Transcol;',			
			local_recarga_informativo_seis: '● Lojas do GVBus;',			
			local_recarga_informativo_sete: '● Agentes de vendas espalhados pelos terminais e nas catracas de entrada desses locais.',		
			local_recarga_informativo_oito: 'Acesse a lista completa dos locais:',
			link_onde_adquirir: 'https://www.cartaogv.com.br/onde-adquirir/',
			falha_na_autenticacao: 'Falha na autenticação. Entre em contato com o suporte!',
			telefone: 'Telefone',

			sub_menu_a:		'Submenu A',
			sub_menu_b:		'Submenu B',
			sub_menu_c:		'Submenu C',
			sub_menu_d:		'Submenu D',
			atencao:		'Atenção',
			
		},

		msg: {
			tooltip: {
				nome: 'Nome',
			},
			vazio: {
				nome: 'Nome precisa ser preenchido',
				informe_codigo_atual: 'Informe o código do cartão atual ou o antigo',
				informe_digito: 'Informe o dígito do cartão',
				informe_numero: 'Informe o número do chip',
				cpf: 'Informe um CPF válido',
			},
			invalido: {
				nome: 'Nome inválido',
				cartao_insuficiente: 'O código do cartão deve ter 14 dígitos. Favor conferir o dado digitado.',
				
			},
			digite_observacao: 'Digite a Observação',
			digite_descricao: 'Digite aqui a Descrição',
			minimo_x_letras: 'Preencha no mínimo uma letra | Preencha no mínimo {qtd} letras',
			carregando: 'Carregando',
			pesquise_nome_menu:	'Pesquise pelo nome do Menu',
			salvo_com_sucesso:	'Salvo com sucesso',
			valida_descricao: 'Você precisa digitar a descrição!',
			valida_nome: 'Você precisa digitar o nome!',
			valida_descricao_observacao: 'Você precisa digitar Descrição e Observação!',
			valida_apagar: 'Tem certeza que deseja apagar',
			valida_email: 'Você precisa digitar um E-mail válido!',
			digite_nome: 'Digite aqui o Nome',
			digite_email: 'Digite aqui o E-mail',
			digite_senha: 'Digite aqui a Senha',
			digite_nome_usuario: 'Digite aqui o seu nome de Usuário',
			orientacoes_senha: 'Sua senha precisa ter entre 4 a 20 caracteres, e não pode conter espaços, caracteres especiais ou emojis'			,
		},

	},

}